(() => {
  const init=(root)=>{
    if(!root||root.dataset.eymqReady==='true')return;
    root.dataset.eymqReady='true';
    const measure=()=>{
      root.querySelectorAll('[data-eymq-track][data-mode="bounce"]').forEach((track)=>{
        const group=track.querySelector('.eymq__group');
        const viewport=track.closest('.eymq__row');
        if(!group||!viewport)return;
        const travel=Math.max(0,group.scrollWidth-viewport.clientWidth);
        track.style.setProperty('--eymq-travel',travel);
      });
    };
    measure();
    if('ResizeObserver' in window){const ro=new ResizeObserver(measure);ro.observe(root)}
    else window.addEventListener('resize',measure);
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-eymq-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());
  else initAll();
  document.addEventListener('shopify:section:load',(e)=>initAll(e.target));
})();